export const EventResultsState = {
  errorMessage: '',
  isLoading: false,
  data: [],
  wasStopped: false,
  args: {}
};

export const EventMetadataState = {
  errorMessage: '',
  isLoading: true,
  data: {}
};

export const EventResultsFiltersState = {
  date: undefined,
  course: undefined,
  division: undefined,
  split: undefined
};



/** WEBPACK FOOTER **
 ** ./model/eventResultsState.js
 **/